export default __webpack_public_path__ + "static/media/side.bd6e214a.jpg";